// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-root {
  width: 100vw;
  height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: column;
  background-color: #f4f6fb;
  overflow: hidden;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: clamp(16px, 3vw, 28px) clamp(20px, 4vw, 40px);
  background: radial-gradient(circle at top left, #eef2ff 0%, #ffffff 45%, #f8fafc 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.09);
  z-index: 1;
}

.app-header h1 {
  margin: 0;
  font-size: clamp(1.25rem, 3vw, 1.85rem);
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.app-title {
  flex: 0 0 auto;
}

.formula-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: nowrap;
}

.formula-select {
  width: 220px;
  min-width: 200px;
  border-radius: 10px;
  border: none;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.3);
  padding: 0.65rem 2.5rem 0.65rem 1.6rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
  background-image: linear-gradient(180deg, rgba(248, 250, 252, 0.9), #ffffff), url(${___CSS_LOADER_URL_REPLACEMENT_0___}http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%231d4ed8' d='M6 8 0 0h12z'/%3E%3C/svg%3E');
  background-repeat: repeat, no-repeat;
  background-position: 0 0, right 1.1rem center;
  background-size: auto, 12px 8px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.formula-select:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
}

.save-button {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 1.6rem;
  font-size: 0.95rem;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.3);
  white-space: nowrap;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.save-button:hover:not(:disabled) {
  box-shadow: 0 18px 32px rgba(37, 99, 235, 0.28);
  transform: translateY(-1px);
}

.save-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  box-shadow: none;
  transform: none;
}

.save-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 1.1rem;
}

.save-icon svg {
  width: 100%;
  height: 100%;
}

.header-icon-button {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: none;
  background: rgba(37, 99, 235, 0.15);
  color: #1d4ed8;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.header-icon-button:hover:not(:disabled) {
  background: rgba(37, 99, 235, 0.25);
}

.header-icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: rgba(148, 163, 184, 0.2);
  color: #475569;
}

.header-icon-button.danger {
  background: rgba(239, 68, 68, 0.2);
  color: #b91c1c;
}

.header-icon-button.danger:hover:not(:disabled) {
  background: rgba(239, 68, 68, 0.3);
  color: #991b1b;
}

.tester-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: clamp(10px, 1.8vw, 18px);
  padding: clamp(12px, 2vw, 24px);
  overflow: hidden;
}

.tester-shell {
  flex: 1;
  min-width: 0;
  display: flex;
  border-radius: 18px;
  background-color: #ffffff;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.tester-shell > * {
  flex: 1;
  min-height: 0;
}

.tester-shell__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: clamp(16px, 2vw, 28px);
  gap: clamp(12px, 1.5vw, 18px);
}

.tester-shell__editor {
  flex: 1;
  min-height: 0;
  display: flex;
}

.tester-shell__editor > * {
  flex: 1;
  min-height: 0;
}

.tester-error-banner {
  border-radius: 14px;
  padding: 0.95rem 1.15rem;
  background: linear-gradient(135deg, rgba(248, 113, 113, 0.15), rgba(248, 113, 113, 0.25));
  border: 1px solid rgba(248, 113, 113, 0.5);
  color: #7f1d1d;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  max-height: clamp(140px, 30vh, 240px);
  overflow: hidden;
}

.tester-error-banner__title {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 0.35rem;
}

.tester-error-banner__message {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'JetBrains Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  color: inherit;
  overflow: auto;
  flex: 1;
}

.testcase-drawer-shell {
  position: relative;
  width: clamp(240px, 24vw, 320px);
  min-width: 220px;
  flex: 0 0 auto;
  transition: width 0.25s ease, min-width 0.25s ease;
}

.testcase-drawer {
  position: relative;
  width: 100%;
  min-height: 100%;
  height: 100%;
  transition: width 0.28s ease;
}

.testcase-drawer.closed {
  width: 0;
}

.testcase-drawer-shell.closed {
  width: 0;
  min-width: 0;
}

.testcase-drawer-shell.closed .testcase-drawer {
  width: 0;
}

.testcase-toggle-rail {
  width: 36px;
  min-width: 36px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 10px;
  margin-left: calc(-1 * clamp(10px, 1.8vw, 18px));
  height: 100%;
  position: relative;
}

.testcase-drawer__toggle {
  width: 100%;
  height: auto;
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.25);
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  padding: 10px 12px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  gap: 6px;
}

.testcase-toggle-rail::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, rgba(37, 99, 235, 0.6), rgba(37, 99, 235, 0.15));
  border-radius: 2px;
  opacity: 0.6;
  pointer-events: none;
}

.testcase-panel {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(37, 99, 235, 0.5);
  border-radius: 18px;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2), 0 16px 36px rgba(15, 23, 42, 0.1);
  display: flex;
  flex-direction: column;
  padding: clamp(18px, 2.5vw, 26px);
  gap: clamp(16px, 2vw, 24px);
  overflow: hidden;
  height: 100%;
  transition: transform 0.28s ease, opacity 0.28s ease;
  border-top-right-radius: 0;
}

.testcase-drawer.closed .testcase-panel {
  transform: translateX(-12px);
  opacity: 0;
  pointer-events: none;
}

.testcase-panel__header h2 {
  margin: 0;
  font-size: 1.15rem;
  color: #0f172a;
}

.testcase-panel__header p {
  margin: 0.25rem 0 0;
  color: #64748b;
  font-size: 0.9rem;
}

.testcase-panel__controls {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.testcase-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.testcase-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.testcase-list__item {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  border: 1px solid #d0d7de;
  background: #ffffff;
  border-radius: 12px;
  padding: 0.6rem 0.7rem 0.6rem 0.85rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.testcase-list__item.is-selected {
  border-color: #1d4ed8;
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.18);
}

.testcase-item__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
}

.testcase-item__name {
  font-weight: 700;
  color: #0f172a;
}

.testcase-item__meta {
  font-size: 0.9rem;
  color: #6b7280;
}

.testcase-item__actions {
  position: relative;
  align-self: center;
}

.testcase-item__menu-trigger {
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(37, 99, 235, 0.08);
  color: #0f172a;
  border-radius: 9px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.1rem;
}

.testcase-item__menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.14);
  min-width: 150px;
  overflow: hidden;
  z-index: 3;
}

.testcase-item__menu button {
  width: 100%;
  background: transparent;
  border: none;
  padding: 0.65rem 0.85rem;
  text-align: left;
  cursor: pointer;
  color: #0f172a;
  font-weight: 600;
}

.testcase-item__menu button:hover:not(:disabled) {
  background: #eff6ff;
}

.testcase-item__menu button.danger {
  color: #b91c1c;
}

.testcase-item__menu button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.testcase-list__empty {
  padding: 0.9rem 1rem;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  color: #64748b;
}

.ghost-button {
  border: 1px solid rgba(37, 99, 235, 0.35);
  background: rgba(37, 99, 235, 0.08);
  color: #1d4ed8;
  padding: 0.55rem 0.9rem;
  font-weight: 600;
  border-radius: 10px;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.ghost-button:hover:not(:disabled) {
  background: rgba(37, 99, 235, 0.18);
  border-color: rgba(37, 99, 235, 0.55);
}

.ghost-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
  background: rgba(148, 163, 184, 0.18);
  border-color: rgba(148, 163, 184, 0.35);
  color: #475569;
}

.ghost-button.danger {
  border-color: rgba(239, 68, 68, 0.35);
  background: rgba(239, 68, 68, 0.1);
  color: #b91c1c;
}

.ghost-button.danger:hover:not(:disabled) {
  border-color: rgba(239, 68, 68, 0.55);
  background: rgba(239, 68, 68, 0.18);
  color: #991b1b;
}

@media (max-width: 1100px) {
  .tester-wrapper {
    flex-direction: column;
    padding-bottom: clamp(18px, 4vw, 32px);
  }

  .testcase-drawer-shell {
    width: 100%;
    min-width: 0;
  }

  .testcase-drawer {
    width: 100%;
  }
}

@media (max-width: 720px) {
  .app-header {
    flex-direction: column;
    align-items: stretch;
  }

  .formula-controls {
    width: 100%;
    align-items: stretch;
  }

  .formula-select-group {
    max-width: none;
  }

  .save-button {
    width: 100%;
    justify-content: center;
  }

  .testcase-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sDAAsD;EACtD,sFAAsF;EACtF,kDAAkD;EAClD,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;EAC9C,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oPAAoP;EACpP,oCAAoC;EACpC,6CAA6C;EAC7C,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,yFAAyF;EACzF,0CAA0C;EAC1C,cAAc;EACd,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,8FAA8F;EAC9F,cAAc;EACd,cAAc;EACd,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,SAAS;EACT,gDAAgD;EAChD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,oFAAoF;EACpF,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;EACxC,mBAAmB;EACnB,+EAA+E;EAC/E,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".app-root {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: #f4f6fb;\n  overflow: hidden;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: clamp(16px, 3vw, 28px) clamp(20px, 4vw, 40px);\n  background: radial-gradient(circle at top left, #eef2ff 0%, #ffffff 45%, #f8fafc 100%);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.35);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.09);\n  z-index: 1;\n}\n\n.app-header h1 {\n  margin: 0;\n  font-size: clamp(1.25rem, 3vw, 1.85rem);\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.app-title {\n  flex: 0 0 auto;\n}\n\n.formula-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: nowrap;\n}\n\n.formula-select {\n  width: 220px;\n  min-width: 200px;\n  border-radius: 10px;\n  border: none;\n  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.3);\n  padding: 0.65rem 2.5rem 0.65rem 1.6rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1f2937;\n  background-image: linear-gradient(180deg, rgba(248, 250, 252, 0.9), #ffffff), url('data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%231d4ed8' d='M6 8 0 0h12z'/%3E%3C/svg%3E');\n  background-repeat: repeat, no-repeat;\n  background-position: 0 0, right 1.1rem center;\n  background-size: auto, 12px 8px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.formula-select:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);\n}\n\n.save-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.65rem 1.6rem;\n  font-size: 0.95rem;\n  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.3);\n  white-space: nowrap;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.save-button:hover:not(:disabled) {\n  box-shadow: 0 18px 32px rgba(37, 99, 235, 0.28);\n  transform: translateY(-1px);\n}\n\n.save-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  box-shadow: none;\n  transform: none;\n}\n\n.save-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.save-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.header-icon-button {\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: none;\n  background: rgba(37, 99, 235, 0.15);\n  color: #1d4ed8;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.header-icon-button:hover:not(:disabled) {\n  background: rgba(37, 99, 235, 0.25);\n}\n\n.header-icon-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  background: rgba(148, 163, 184, 0.2);\n  color: #475569;\n}\n\n.header-icon-button.danger {\n  background: rgba(239, 68, 68, 0.2);\n  color: #b91c1c;\n}\n\n.header-icon-button.danger:hover:not(:disabled) {\n  background: rgba(239, 68, 68, 0.3);\n  color: #991b1b;\n}\n\n.tester-wrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  gap: clamp(10px, 1.8vw, 18px);\n  padding: clamp(12px, 2vw, 24px);\n  overflow: hidden;\n}\n\n.tester-shell {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  border-radius: 18px;\n  background-color: #ffffff;\n  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n}\n\n.tester-shell > * {\n  flex: 1;\n  min-height: 0;\n}\n\n.tester-shell__body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: clamp(16px, 2vw, 28px);\n  gap: clamp(12px, 1.5vw, 18px);\n}\n\n.tester-shell__editor {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n\n.tester-shell__editor > * {\n  flex: 1;\n  min-height: 0;\n}\n\n.tester-error-banner {\n  border-radius: 14px;\n  padding: 0.95rem 1.15rem;\n  background: linear-gradient(135deg, rgba(248, 113, 113, 0.15), rgba(248, 113, 113, 0.25));\n  border: 1px solid rgba(248, 113, 113, 0.5);\n  color: #7f1d1d;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  max-height: clamp(140px, 30vh, 240px);\n  overflow: hidden;\n}\n\n.tester-error-banner__title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 0.35rem;\n}\n\n.tester-error-banner__message {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.4;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: 'JetBrains Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;\n  color: inherit;\n  overflow: auto;\n  flex: 1;\n}\n\n.testcase-drawer-shell {\n  position: relative;\n  width: clamp(240px, 24vw, 320px);\n  min-width: 220px;\n  flex: 0 0 auto;\n  transition: width 0.25s ease, min-width 0.25s ease;\n}\n\n.testcase-drawer {\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n  height: 100%;\n  transition: width 0.28s ease;\n}\n\n.testcase-drawer.closed {\n  width: 0;\n}\n\n.testcase-drawer-shell.closed {\n  width: 0;\n  min-width: 0;\n}\n\n.testcase-drawer-shell.closed .testcase-drawer {\n  width: 0;\n}\n\n.testcase-toggle-rail {\n  width: 36px;\n  min-width: 36px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-left: calc(-1 * clamp(10px, 1.8vw, 18px));\n  height: 100%;\n  position: relative;\n}\n\n.testcase-drawer__toggle {\n  width: 100%;\n  height: auto;\n  background: linear-gradient(135deg, #1d4ed8, #2563eb);\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.25);\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  padding: 10px 12px;\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  align-items: center;\n  justify-content: center;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.testcase-toggle-rail::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, rgba(37, 99, 235, 0.6), rgba(37, 99, 235, 0.15));\n  border-radius: 2px;\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.testcase-panel {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid rgba(37, 99, 235, 0.5);\n  border-radius: 18px;\n  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2), 0 16px 36px rgba(15, 23, 42, 0.1);\n  display: flex;\n  flex-direction: column;\n  padding: clamp(18px, 2.5vw, 26px);\n  gap: clamp(16px, 2vw, 24px);\n  overflow: hidden;\n  height: 100%;\n  transition: transform 0.28s ease, opacity 0.28s ease;\n  border-top-right-radius: 0;\n}\n\n.testcase-drawer.closed .testcase-panel {\n  transform: translateX(-12px);\n  opacity: 0;\n  pointer-events: none;\n}\n\n.testcase-panel__header h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  color: #0f172a;\n}\n\n.testcase-panel__header p {\n  margin: 0.25rem 0 0;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.testcase-panel__controls {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.testcase-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.testcase-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.testcase-list__item {\n  display: flex;\n  align-items: stretch;\n  gap: 0.5rem;\n  border: 1px solid #d0d7de;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 0.6rem 0.7rem 0.6rem 0.85rem;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.testcase-list__item.is-selected {\n  border-color: #1d4ed8;\n  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.18);\n}\n\n.testcase-item__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  background: transparent;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n}\n\n.testcase-item__name {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.testcase-item__meta {\n  font-size: 0.9rem;\n  color: #6b7280;\n}\n\n.testcase-item__actions {\n  position: relative;\n  align-self: center;\n}\n\n.testcase-item__menu-trigger {\n  border: 1px solid rgba(148, 163, 184, 0.5);\n  background: rgba(37, 99, 235, 0.08);\n  color: #0f172a;\n  border-radius: 9px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.1rem;\n}\n\n.testcase-item__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: #ffffff;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 12px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.14);\n  min-width: 150px;\n  overflow: hidden;\n  z-index: 3;\n}\n\n.testcase-item__menu button {\n  width: 100%;\n  background: transparent;\n  border: none;\n  padding: 0.65rem 0.85rem;\n  text-align: left;\n  cursor: pointer;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.testcase-item__menu button:hover:not(:disabled) {\n  background: #eff6ff;\n}\n\n.testcase-item__menu button.danger {\n  color: #b91c1c;\n}\n\n.testcase-item__menu button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.testcase-list__empty {\n  padding: 0.9rem 1rem;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.ghost-button {\n  border: 1px solid rgba(37, 99, 235, 0.35);\n  background: rgba(37, 99, 235, 0.08);\n  color: #1d4ed8;\n  padding: 0.55rem 0.9rem;\n  font-weight: 600;\n  border-radius: 10px;\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.ghost-button:hover:not(:disabled) {\n  background: rgba(37, 99, 235, 0.18);\n  border-color: rgba(37, 99, 235, 0.55);\n}\n\n.ghost-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  background: rgba(148, 163, 184, 0.18);\n  border-color: rgba(148, 163, 184, 0.35);\n  color: #475569;\n}\n\n.ghost-button.danger {\n  border-color: rgba(239, 68, 68, 0.35);\n  background: rgba(239, 68, 68, 0.1);\n  color: #b91c1c;\n}\n\n.ghost-button.danger:hover:not(:disabled) {\n  border-color: rgba(239, 68, 68, 0.55);\n  background: rgba(239, 68, 68, 0.18);\n  color: #991b1b;\n}\n\n@media (max-width: 1100px) {\n  .tester-wrapper {\n    flex-direction: column;\n    padding-bottom: clamp(18px, 4vw, 32px);\n  }\n\n  .testcase-drawer-shell {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .testcase-drawer {\n    width: 100%;\n  }\n}\n\n@media (max-width: 720px) {\n  .app-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .formula-controls {\n    width: 100%;\n    align-items: stretch;\n  }\n\n  .formula-select-group {\n    max-width: none;\n  }\n\n  .save-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .testcase-actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
